import type React from "react";
const AboutPage: React.FC = () => {
  return (
    <div>
      <section className="relative bg-red-600 text-white">
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('/images/hero/hero1.png')`,
            backgroundBlendMode: "overlay",
          }}
        ></div>
        <div className="container mx-auto px-4 py-16 relative z-10">
          <div className="min-h-[120px]" aria-hidden="true"></div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl">
            <h2 className="text-3xl font-bold mb-6 relative inline-block">
              About Sinopec
              <span className="absolute bottom-0 left-0 w-16 h-1 bg-red-600" style={{ marginBottom: "-8px" }}></span>
            </h2>
            <p className="text-gray-600 mb-6">
              Sinopec is one of the world&apos;s largest energy, refining, petrochemical, and lubricant companies, consistently ranked among the world&apos;s largest companies by revenue, including No. 6 on the 2025 Fortune Global 500. Its integrated business covers upstream and downstream operations, production, supply, marketing, and international trading, giving Sinopec the scale and technical base to serve major industrial and commercial markets worldwide.
            </p>
            <p className="text-gray-600 mb-6">
              As a major global refining player and lubricant manufacturer, Sinopec serves industrial, commercial, transportation, construction, mining, agriculture, marine, and equipment markets worldwide. Sinopec Lubricants has large-scale production and technical development capabilities, producing more than 1.46 million tons of packaged lubricants per year through 12 lube oil and grease blending and manufacturing branches, supported by 2 major R&amp;D centres in the Asia-Pacific region.
            </p>
            <p className="text-gray-600">
              Its product portfolio includes more than 2,000 kinds of lube oils and greases across 21 major product categories, covering hydraulic oils, engine oils, gear oils, compressor oils, turbine oils, transmission fluids, coolants, marine oils, greases, and specialty products for demanding operating environments.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
